import React from "react";
import PropTypes from "prop-types";


import { Element } from "rc-scroll-anim";

import carousel1 from "../assets/imgs/carousel1.webp";
import carousel2 from "../assets/imgs/carousel2.webp";
import carousel3 from "../assets/imgs/carousel3.webp";

import quality1 from "../assets/imgs/quality1.webp";
import quality2 from "../assets/imgs/quality2.webp";
import quality3 from "../assets/imgs/quality3.webp";
import quality4 from "../assets/imgs/quality4.webp";

import arlicarTitle from "../assets/imgs/arlicarTitle.webp";
import arlicar1 from "../assets/imgs/arlicar1.webp";
import arlicar2 from "../assets/imgs/arlicar2.webp";
import arlicar3 from "../assets/imgs/arlicar3.webp";


import faqTitle from "../assets/imgs/faqTitle.webp";
import faq1 from "../assets/imgs/faq1.webp";
import faq2 from "../assets/imgs/faq2.webp";
import faq3 from "../assets/imgs/faq3.webp";
import faq4 from "../assets/imgs/faq4.webp";

import google from "../assets/imgs/google.webp";






import { Carousel } from 'antd';
class Banner extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    navToShadow: PropTypes.func,
  };
  static defaultProps = {
    className: "banner",
  };
  constructor(props) {
    super(props);
    this.state = {
      appUrl: "",
      phone: '',
      serviceEmail: ''
    };
  }
  componentDidMount() {

    const {location: {pathname}} = window


    fetch(window.location.origin + "/nuestraApl", {
      method: "GET",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      mode: "no-cors",
      cache: "default",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.ret === 0) {
          const { data = {} } = res;
          const {servicePhone='', serviceEmail=null} = res.data
          this.setState({
            appUrl: pathname.indexOf('/download') > - 1 ? 'https://www.prestman.tech/PrestMan-1.3.1-release.apk' : data.url,
            phone:  servicePhone ? servicePhone.replace("+52", "+52 ", 1) : null,
            serviceEmail: serviceEmail ? serviceEmail : null
          });
        }
      });
  }

  handleDownload = () =>{
    const { appUrl } = this.state;
    window.location.href = appUrl
  }

  
  render() {
    const { className, navToShadow, isMobile } = this.props;
    const {phone, serviceEmail} = this.state

    const Footer = () => {


     
      return (
        <div id="footer" className={"footer"}>
          <div className="footerLeft">
            <div className="title">
              Sobre Nosotros
            </div>
            <a className={["desc", isMobile && 'phone'].join(' ')} href={`tel:${phone}`}>{phone}</a>
            <div className="desc">
              {serviceEmail}
            </div>
            <div className="desc">
              Horario de servicio: 9:00 am - 18:00 pm
            </div>
          </div>
          <img alt='google' src={google} className='google' onClick={()=>this.handleDownload()}/>
        </div>
      );
    };


    const quality = () => {
      return (
        <div className='quality'>
          {
            [
              {
                img: quality1,
                title: 'Descargar'
              },
              {
                img: quality2,
                title: 'Subir INE'
              },
              {
                img: quality3,
                title: 'Ingresar Información'
              },
              {
                img: quality4,
                title: 'Depósito Exitoso'
              }
            ].map((item,index)=>{
            return <div className='qualityItem' key={item.title}>
              <div className="left">
                <img src={item.img} alt={item.title}/>
                <div className="title">{item.title}</div>
              </div>
              {index !== 3 ? <div className="right"/> : null}
            </div>
            })
          }
        </div>
      )
    }

    const arlicar = () => {
      return (
        <div className='arlicar'>
          <div className='arlicarTitle'>
            <img src={arlicarTitle} className='arlicarImg' alt={'arlicarTitle'}/>
            <div >solo necesitas:</div>
          </div>

          <div className='arlicarRight'>
            {
            [
              {
                img: arlicar1,
                title: 'Ciudadano Mexicano',
                desc: 'Mayor de 18 años'
              },
              {
                img: arlicar2,
                title: 'INE Vigente',
                desc: 'Debes tenerlo a la mano'
              },
              {
                img: arlicar3,
                title: 'Contar Con Un Celular',
                desc: 'Descarga PrestMan MX'
              },
            ].map(item=>{
            return <div className='arlicarItem' key={item.title}>
                <img src={item.img} alt={item.title}/>
                <div className="title">{item.title}</div>
                <div className="desc">{item.desc}</div>
            </div>
            })
          }
          </div>
        </div>
      )
    }


    const faq = () => {
      return (
        <div className='faq'>
          <img src={faqTitle} className='faqImg' alt={'faqTitle'}/>


          <div className='faqContent'>
            {
            [
              {
                img: faq1,
                title: 'Múltiples Opciones Y Depósito Rápido',
                desc: '¡Tú eliges el monto, plazo y número de pagos! Además, al confirmar tu préstamo, el dinero llega al instante.'
              },
              {
                img: faq2,
                title: 'A Mayor Monto, Menor Interés',
                desc: 'Mientras más préstamos cumplas, tu tasa de interés baja y tu línea de crédito aumenta.'
              },
              {
                img: faq3,
                title: 'Flexibilidad A Tu Medida: ¡Paga A Plazos!',
                desc: 'Puedes dividir tu pago en cantidades pequeñas, sin necesidad de desembolsar todo de una vez. Alivia tu presión financiera con pagos adaptados a ti.'
              },
              {
                img: faq4,
                title: 'Paga Con Flexibilidad: ¡24/7!',
                desc: 'Aceptamos pagos en línea y en tiendas de conveniencia​​​',
                desc1: 'Desde cualquier lugar​',
                desc2: 'Fácil y rápido'
              },
            ].map((item, index)=>{
            return <div className={['faqItem', index % 2 === 0 && 'faqRight'].join(' ')} key={item.title}>
                <img src={item.img} alt={item.title}/>
                <div className="itemContent">
                  <div className="title">{item.title}</div>
                  <div className="desc">{item.desc}</div>
                  {item.desc1 ? <div className="desc">{item.desc1}</div> : null}
                  {item.desc2 ? <div className="desc">{item.desc2}</div> : null}
                </div>
            </div>
            })
          }
          </div>
        </div>
      )
    }
    return (
      <Element
        id="home"
        component="section"
        className={isMobile ? "block-mobile " : "block"}
        onChange={navToShadow}
      >
        <div className={className + (isMobile ? "-mobile " : "")}>
          

          <div className={`content`}>
            <Carousel  effect="scrollx" autoplay autoplaySpeed={5000}>
              {
                [
                  {
                    img: carousel1,
                  },
                  {
                    img: carousel2,
                  },
                  {
                    img: carousel3,
                  }
                ].map((item,index)=>{
                  return <img alt="carouselImg" onClick={()=>this.handleDownload()} key={index} src={item.img} className='carouselImg'/>
                })
              }
            </Carousel>
          </div>
          <div className={'article'}>
            <div className={'articleTitle'}>FÁCIL Y RÁPIDO</div>
            <div className={'articleDesc'}>COBRA EN 4 PASOS</div>
          </div>
          {quality()}
          {arlicar()}
          {faq()}
          <Footer />
        </div>
      </Element>
    );
  }
}

export default Banner;
